import { render, staticRenderFns } from "./AlarmWatch.vue?vue&type=template&id=7980e6de&scoped=true&"
import script from "./AlarmWatch.vue?vue&type=script&lang=js&"
export * from "./AlarmWatch.vue?vue&type=script&lang=js&"
import style0 from "./AlarmWatch.vue?vue&type=style&index=0&id=7980e6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980e6de",
  null
  
)

export default component.exports